// API base URL.
// - Local dev (vite dev server): relative `/api` so Vite's proxy forwards to
//   localhost:7071 (see vite.config.ts).
// - Production: call the Function App directly. SWA's backend-link feature is
//   unavailable on Functions Consumption plans, so cross-origin via CORS is the path.
const PROD_API = 'https://purchasing-api-v1.azurewebsites.net/api';

function resolveApiBase(): string {
  const fromEnv = import.meta.env.VITE_API_URL;
  if (fromEnv && fromEnv !== '/api') return fromEnv;
  if (typeof window === 'undefined') return PROD_API;
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return '/api';
  return PROD_API;
}

export const API_BASE_URL = resolveApiBase();
